(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-add-ons"] && !Shopify.designMode) return;
  try {
    /**
   * Frequently bought together: "ADD BOTH" adds the selected main-product variant and the add-on
   * in one cart request, for the combined price shown on the button. The combined price follows
   * the main product's variant picker (variant:update) and the add-on's colour/variant choice.
   */
  class ProductAddOns extends HTMLElement {
    connectedCallback() {
      // The block schema's "tag" wraps this markup in a second <product-add-ons>; only the inner
      // element (which carries the data attributes) runs, otherwise every click is bound twice.
      if (!this.dataset.productId) return;
      if (!this.bound) {
        this.bound = true;
        this.mainPrice = Number(this.dataset.mainPrice) || 0;
        this.mainAvailable = this.dataset.mainAvailable !== 'false';
        this.mainVariantId = this.dataset.mainVariantId;
        this.onVariantUpdate = this.onVariantUpdate.bind(this);
        this.setHostHidden(this.hasAttribute('data-empty'));
        this.bindEvents();
      }
      document.addEventListener('variant:update', this.onVariantUpdate);
    }

    disconnectedCallback() {
      if (this.onVariantUpdate) document.removeEventListener('variant:update', this.onVariantUpdate);
    }

    formatMoney(cents) {
      const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      try {
        const whole = cents % 100 === 0;
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(cents / 100);
      } catch (e) {
        return '$' + (cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2));
      }
    }

    /** The main product form's selected variant id (falls back to the variant rendered with the page). */
    getMainVariantId() {
      // Only the form for this product counts (the cart drawer and upsells have their own product forms)
      const form = document.querySelector('product-form-component[data-product-id="' + this.dataset.productId + '"] form');
      const input = form && form.querySelector('input[name="id"]');
      return (input && input.value) || this.mainVariantId;
    }

    onVariantUpdate(event) {
      const detail = event.detail || {};
      const data = detail.data || {};
      if (String(data.productId) !== String(this.dataset.productId)) return;
      const variant = detail.resource;
      if (!variant) return;
      this.mainVariantId = String(variant.id);
      if (typeof variant.price === 'number') this.mainPrice = variant.price;
      this.mainAvailable = variant.available !== false;
      // A new colour can bring its own add-on list (variant metafield) and a matching add-on colour:
      // take the cards from the section HTML the variant picker already fetched (no extra request).
      const fresh = data.html && data.html.querySelector('product-add-ons[data-product-id="' + this.dataset.productId + '"]');
      if (fresh && fresh.dataset.addonsKey !== this.dataset.addonsKey) this.replaceFrom(fresh);
      this.querySelectorAll('.product-add-on').forEach((card) => this.refreshCard(card));
    }

    replaceFrom(fresh) {
      this.innerHTML = fresh.innerHTML;
      this.dataset.addonsKey = fresh.dataset.addonsKey || '';
      this.toggleAttribute('data-empty', fresh.hasAttribute('data-empty'));
      this.setHostHidden(fresh.hasAttribute('data-empty'));
      this.bindEvents();
    }

    /** Hide the block (and the schema-tag wrapper around it) while the selected colour has no add-ons. */
    setHostHidden(hidden) {
      this.hidden = hidden;
      const host = this.parentElement;
      if (host && host.tagName === this.tagName && !host.dataset.productId) host.hidden = hidden;
    }

    refreshCard(card) {
      const button = card.querySelector('.product-add-on__atc-button');
      if (!button || button.dataset.autoAdd === 'true') return;
      const addonPrice = Number(button.dataset.addonPrice) || 0;
      const addonAvailable = button.dataset.addonAvailable !== 'false';
      const combo = card.querySelector('.product-add-on__combo-price');
      if (combo) combo.textContent = this.formatMoney(this.mainPrice + addonPrice);
      const available = addonAvailable && this.mainAvailable;
      button.disabled = !available;
      const label = card.querySelector('.product-add-on__atc-label');
      if (label) label.hidden = !available;
      let soldOut = card.querySelector('.product-add-on__sold-out');
      if (!available && !soldOut && label) {
        soldOut = document.createElement('span');
        soldOut.className = 'product-add-on__sold-out';
        soldOut.textContent = this.dataset.labelSoldOut;
        label.after(soldOut);
      }
      if (soldOut) soldOut.hidden = available;
      if (this.qvCard === card) this.syncQuickView();
    }

    /** Apply an add-on colour/variant choice (swatch button or dropdown option) to its card. */
    selectAddonVariant(card, source) {
      const ds = source.dataset;
      const button = card.querySelector('.product-add-on__atc-button');
      const image = card.querySelector('.product-add-on__image img');
      const price = card.querySelector('.product-add-on__price-current');
      const colorLabel = card.querySelector('.product-add-on__selected-color');
      const variantId = ds.variantId || source.value;
      if (button && variantId) button.dataset.variantId = variantId;
      if (button && ds.variantPriceCents) button.dataset.addonPrice = ds.variantPriceCents;
      if (button && ds.variantAvailable) button.dataset.addonAvailable = ds.variantAvailable;
      if (image && ds.variantImage) {
        image.src = ds.variantImage;
        image.removeAttribute('srcset');
      }
      if (price && ds.variantPrice) price.textContent = ds.variantPrice;
      if (colorLabel && ds.colorName) colorLabel.textContent = ds.colorName;
      this.refreshCard(card);
      if (this.qvCard === card) this.syncQuickView(ds.variantMediaId);
    }

    /** Carousel arrows only show where the list actually scrolls sideways (never on phones, where cards stack). */
    updateNav() {
      if (!this.list || !this.prevBtn || !this.nextBtn) return;
      const list = this.list;
      const scrollable = list.scrollWidth > list.clientWidth + 1;
      this.prevBtn.parentElement.hidden = !scrollable;
      this.prevBtn.disabled = list.scrollLeft <= 1;
      this.nextBtn.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 1;
    }

    /* ---------- Quick view: the add-on's photos, price, colours and description without leaving the page ---------- */

    openQuickView(card, opener) {
      const dialog = this.qvDialog;
      const template = card.querySelector('.product-add-on__qv-template');
      if (!dialog || !template || typeof dialog.showModal !== 'function') return;
      const body = dialog.querySelector('.product-add-on-qv__body');
      body.replaceChildren(template.content.cloneNode(true));
      const title = body.querySelector('[data-qv-title]');
      if (title) title.id = body.dataset.titleId;
      this.qvCard = card;
      this.qvOpener = opener;

      // Colour choice: a copy of the card's swatches (or dropdown) that drives the card, so there is one source of truth
      const options = body.querySelector('[data-qv-options]');
      const cardOptions = card.querySelector('.product-add-on__swatch-wrapper, .product-add-on__variant-selector');
      if (options && cardOptions) {
        options.append(cardOptions.cloneNode(true));
        const cardSwatches = [...card.querySelectorAll('.product-add-on__swatch-btn')];
        options.querySelectorAll('.product-add-on__swatch-btn').forEach((swatch, i) => {
          swatch.addEventListener('click', () => cardSwatches[i] && cardSwatches[i].click());
        });
        const select = options.querySelector('select');
        const cardSelect = card.querySelector('.product-add-on__variant-dropdown');
        if (select && cardSelect) {
          select.removeAttribute('data-addon-index');
          select.addEventListener('change', () => {
            cardSelect.value = select.value;
            cardSelect.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }
      }

      const add = body.querySelector('[data-qv-add]');
      if (add) {
        add.addEventListener('click', () => {
          if (!add.disabled && add.dataset.variantId) this.addBoth(add);
        });
      }

      const slides = body.querySelector('.product-add-on-qv__slides');
      if (slides) {
        const counter = body.querySelector('[data-qv-index]');
        const prev = body.querySelector('.product-add-on-qv__arrow--prev');
        const next = body.querySelector('.product-add-on-qv__arrow--next');
        const update = () => {
          const index = Math.round(slides.scrollLeft / Math.max(slides.clientWidth, 1));
          if (counter) counter.textContent = String(index + 1);
          if (prev) prev.disabled = index <= 0;
          if (next) next.disabled = index >= slides.children.length - 1;
        };
        slides.addEventListener('scroll', update, { passive: true });
        if (prev) prev.addEventListener('click', () => slides.scrollBy({ left: -slides.clientWidth, behavior: 'smooth' }));
        if (next) next.addEventListener('click', () => slides.scrollBy({ left: slides.clientWidth, behavior: 'smooth' }));
        this.qvUpdateSlides = update;
      }

      const active = card.querySelector('.product-add-on__swatch-btn.is-active') ||
        (card.querySelector('.product-add-on__variant-dropdown') || {}).selectedOptions?.[0];
      dialog.showModal();
      this.syncQuickView(active && active.dataset.variantMediaId, true);
      const close = dialog.querySelector('.product-add-on-qv__close');
      if (close) close.focus({ preventScroll: true });
    }

    closeQuickView() {
      if (this.qvDialog && this.qvDialog.open) this.qvDialog.close();
    }

    /** Copy the card's current state (price, colour, add button) into the open quick view. */
    syncQuickView(mediaId, instant) {
      const card = this.qvCard;
      const dialog = this.qvDialog;
      if (!card || !dialog || !dialog.open) return;
      const body = dialog.querySelector('.product-add-on-qv__body');

      const price = body.querySelector('[data-qv-price]');
      const cardPrice = card.querySelector('.product-add-on__price');
      if (price && cardPrice) price.innerHTML = cardPrice.innerHTML;

      const cardSwatches = [...card.querySelectorAll('.product-add-on__swatch-btn')];
      body.querySelectorAll('[data-qv-options] .product-add-on__swatch-btn').forEach((swatch, i) => {
        const source = cardSwatches[i];
        if (!source) return;
        swatch.classList.toggle('is-active', source.classList.contains('is-active'));
        swatch.setAttribute('aria-pressed', source.getAttribute('aria-pressed') || 'false');
      });
      const label = body.querySelector('[data-qv-options] .product-add-on__selected-color');
      const cardLabel = card.querySelector('.product-add-on__selected-color');
      if (label && cardLabel) label.textContent = cardLabel.textContent;
      const select = body.querySelector('[data-qv-options] select');
      const cardSelect = card.querySelector('.product-add-on__variant-dropdown');
      if (select && cardSelect) select.value = cardSelect.value;

      const add = body.querySelector('[data-qv-add]');
      const cardAdd = card.querySelector('.product-add-on__atc-button');
      if (add && cardAdd) {
        if (!add.classList.contains('product-add-on__atc-button--added') && add.dataset.busy !== 'true') {
          add.innerHTML = cardAdd.innerHTML;
          add.disabled = cardAdd.disabled || cardAdd.dataset.autoAdd === 'true';
        }
        add.dataset.variantId = cardAdd.dataset.variantId || '';
        add.hidden = cardAdd.dataset.autoAdd === 'true';
        const link = body.querySelector('[data-qv-link]');
        if (link && cardAdd.dataset.variantId) link.href = link.dataset.baseUrl + '?variant=' + cardAdd.dataset.variantId;
      }

      // Show the chosen colour's photo
      const slides = body.querySelector('.product-add-on-qv__slides');
      if (slides && mediaId) {
        const slide = slides.querySelector('[data-media-id="' + mediaId + '"]');
        if (slide) slides.scrollTo({ left: slide.offsetLeft, behavior: instant ? 'auto' : 'smooth' });
      }
      if (this.qvUpdateSlides) this.qvUpdateSlides();
    }

    bindEvents() {
      this.list = this.querySelector('.product-add-ons__list');
      this.prevBtn = this.querySelector('.product-add-ons__nav-prev');
      this.nextBtn = this.querySelector('.product-add-ons__nav-next');
      if (this.prevBtn && this.list) {
        this.prevBtn.addEventListener('click', () => this.list.scrollBy({ left: -this.list.clientWidth, behavior: 'smooth' }));
      }
      if (this.nextBtn && this.list) {
        this.nextBtn.addEventListener('click', () => this.list.scrollBy({ left: this.list.clientWidth, behavior: 'smooth' }));
      }
      if (this.list && this.prevBtn) {
        this.list.addEventListener('scroll', () => this.updateNav(), { passive: true });
        if (!this.navObserver && 'ResizeObserver' in window) this.navObserver = new ResizeObserver(() => this.updateNav());
        if (this.navObserver) {
          this.navObserver.disconnect();
          this.navObserver.observe(this.list);
        }
        this.updateNav();
      }

      // Quick view (the dialog is replaced with the cards when the main colour changes)
      this.qvCard = null;
      this.qvDialog = this.querySelector('dialog.product-add-on-qv');
      if (this.qvDialog) {
        const dialog = this.qvDialog;
        dialog.querySelector('.product-add-on-qv__close')?.addEventListener('click', () => this.closeQuickView());
        // A tap on the backdrop (outside the panel) closes it
        dialog.addEventListener('click', (e) => {
          if (e.target === dialog) this.closeQuickView();
        });
        dialog.addEventListener('close', () => {
          const opener = this.qvOpener;
          this.qvCard = null;
          this.qvOpener = null;
          this.qvUpdateSlides = null;
          dialog.querySelector('.product-add-on-qv__body').replaceChildren();
          // After the browser's own focus restore (which can land on the photo button), move to the title
          if (opener && opener.isConnected) requestAnimationFrame(() => opener.focus({ preventScroll: true }));
        });
      }
      this.querySelectorAll('.product-add-on__qv-open').forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          const card = e.currentTarget.closest('.product-add-on');
          if (!card) return;
          // Focus returns to the title button (the photo button is hidden from keyboard and screen readers)
          this.openQuickView(card, card.querySelector('.product-add-on__title .product-add-on__qv-open'));
        });
      });

      this.querySelectorAll('.product-add-on__swatch-btn').forEach((swatch) => {
        swatch.addEventListener('click', (e) => {
          const btn = e.currentTarget;
          const card = btn.closest('.product-add-on');
          if (!card) return;
          card.querySelectorAll('.product-add-on__swatch-btn').forEach((s) => {
            s.classList.remove('is-active');
            s.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
          this.selectAddonVariant(card, btn);
        });
      });

      this.querySelectorAll('.product-add-on__variant-dropdown').forEach((dropdown) => {
        dropdown.addEventListener('change', (e) => {
          const card = e.currentTarget.closest('.product-add-on');
          const option = e.currentTarget.selectedOptions[0];
          if (card && option) this.selectAddonVariant(card, option);
        });
      });

      this.querySelectorAll('.product-add-on__atc-button').forEach((button) => {
        if (button.dataset.autoAdd === 'true') return;
        button.addEventListener('click', (e) => {
          const btn = e.currentTarget;
          if (btn.disabled || !btn.dataset.variantId) return;
          this.addBoth(btn);
        });
      });
    }

    async addBoth(button) {
      const originalHTML = button.innerHTML;
      const mainVariantId = this.getMainVariantId();
      const addonVariantId = button.dataset.variantId;
      button.disabled = true;
      button.dataset.busy = 'true';
      button.textContent = this.dataset.labelAdding;

      const sectionIds = [...document.querySelectorAll('cart-items-component')]
        .map((el) => el.dataset.sectionId)
        .filter(Boolean);
      const items = [];
      if (mainVariantId) items.push({ id: Number(mainVariantId), quantity: 1 });
      items.push({ id: Number(addonVariantId), quantity: 1 });

      try {
        const addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
        const response = await fetch(addUrl.endsWith('.js') ? addUrl : addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items, sections: sectionIds.join(',') }),
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok || result.status) {
          throw new Error(result.description || result.message || this.dataset.labelError);
        }

        // From the quick view: close it first so the cart drawer is not opened underneath it
        delete button.dataset.busy;
        if (this.qvDialog && this.qvDialog.contains(button)) this.closeQuickView();

        let itemCount = items.length;
        try {
          const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
          itemCount = cart.item_count;
        } catch (e) {}

        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: addonVariantId,
            data: {
              source: 'product-add-ons',
              itemCount,
              productId: this.dataset.productId,
              sections: result.sections || {},
            },
          },
        }));

        button.textContent = this.dataset.labelAdded;
        button.classList.add('product-add-on__atc-button--added');
        setTimeout(() => {
          button.innerHTML = originalHTML;
          button.classList.remove('product-add-on__atc-button--added');
          const card = button.closest('.product-add-on');
          if (card) this.refreshCard(card);
          else button.disabled = false;
        }, 2000);
      } catch (error) {
        console.error('Add-on cart error:', error);
        delete button.dataset.busy;
        button.textContent = this.dataset.labelTryAgain;
        const card = button.closest('.product-add-on');
        const msgHost = card || button.closest('.product-add-on-qv__actions');
        let msg = msgHost && msgHost.querySelector('.product-add-on__error');
        if (msgHost && !msg) {
          msg = document.createElement('p');
          msg.className = 'product-add-on__error';
          msg.setAttribute('role', 'alert');
          button.after(msg);
        }
        if (msg) msg.textContent = error.message;
        setTimeout(() => {
          button.innerHTML = originalHTML;
          if (card) this.refreshCard(card);
          else button.disabled = false;
        }, 3000);
      }
    }
  }

  if (!customElements.get('product-add-ons')) customElements.define('product-add-ons', ProductAddOns);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-size-selector"] && !Shopify.designMode) return;
  try {
    class ProductSizeSelector {
    constructor() {
      this.initCompareDrawers();
      this.initTangibleePlacement();
    }

    initCompareDrawers() {
      document.querySelectorAll('[data-compare-drawer-trigger]').forEach((trigger) => {
        const blockId = trigger.dataset.compareDrawerTrigger;
        const drawer = document.querySelector(`[data-compare-drawer="${blockId}"]`);

        if (!drawer) return;

        trigger.addEventListener('click', () => {
          drawer.showModal();
        });
      });
    }

    initTangibleePlacement() {
      const root = document.querySelector('.main_product .product-details');
      const slot = document.querySelector('[data-tangiblee-slot]');

      if (!root || !slot) return;

      const moveTangibleeCta = () => {
        const tangibleeCta = root.querySelector('.tangiblee-cta');

        if (!tangibleeCta || tangibleeCta.parentElement === slot) return;

        slot.appendChild(tangibleeCta);
      };

      moveTangibleeCta();

      const observer = new MutationObserver(moveTangibleeCta);
      observer.observe(root, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new ProductSizeSelector());
  } else {
    new ProductSizeSelector();
  }
  } catch(e) { console.error(e); }
})();

})();
